import ZJApp from "../../../../app";

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
  service: "BaseDataService",
  controller: "Scenic",
};

const methods = [
  "GetAllScenic"
];

const factory = (Fun) => {
  utils.extend(Fun.prototype, info);
  methods.forEach((path) => {
      Fun.prototype[path] = function(data) {
        return this.post(path, data);
      };
  });
};

const ScenicApi = ZJApi.defineNewApi("ScenicApi", factory);

export default ScenicApi;
